import { createContext, useContext, useState } from "react";
import { getAdminsList } from "../api/admin.api";
import { getReviewsList } from "../api/reviews.api";
import {
  getProductCategoriesByBarList,
  getProductCategoriesList,
} from "../api/product-categories.api";
import {
  getProductSubCategoriesByCatList,
  getProductSubCategoriesList,
} from "../api/product-sub-categories.api";
import { getProductConfigsByProductsList, getProductConfigsList, getProductImages, getProductsList } from "../api/products.api";
import { getUsersList } from "../api/users.api";
import { useAuth } from "./authContext";
import { getAttributesList, getColorsList, getFinishesList, getMaterialsList, getSizesList, getStoragesList } from "../api/attributes.api";
import { getBrandsList } from "../api/brands.api";
import { getProductCategoriesBarList } from "../api/product-categories-bar.api";
import { getCountsData } from "../api/count.api";
import { getAnalytics, getOrderAnalytics, getOrdersList } from "../api/orders.api";
import { getCityList } from "../api/city.api";
import { getUserTypesList } from "../api/user-types.api";
import { getSliderList, getSliderTypeList } from "../api/slider.api";
import { getStoreList } from "../api/store.api";
import { getBlogList } from "../api/blog.api";
import { getTestimonialList } from "../api/testimonials.api";

const ListContext = createContext();

export const useLists = () => useContext(ListContext);

const ListProvider = ({ children }) => {
  const { config } = useAuth();
  const [title, setTitle] = useState("");
  // const [ refresh, setRefresh ] = useState(false);
  const [ countList, setCountList ] = useState([]);
  const [adminsList, setAdminsList] = useState([]);
  const [usersList, setUsersList] = useState([]);
  const [ cityList, setCityList ] = useState([]);
  const [ blogList, setBlogList ] = useState([]);
  const [ testimonialList, setTestimonialList ] = useState([]);
  const [ storeList, setStoreList ] = useState([]);
  const [brandsList, setBrandsList] = useState([]);
  const [ userTypesList, setUserTypesList ] = useState([]);
  const [ ordersList, setOrdersList ] = useState([]);
  const [ analyticsData, setAnalyticsData ] = useState([]);
  const [ orderAnalytics, setOrderAnalytics ] = useState([]);
  const [productsList, setProductsList] = useState([]);
  const [ productConfigsList, setProductConfigsList ] = useState([]);
  const [ productConfigsByProductsList, setProductConfigsByProductsList ] = useState([]);
  const [attributesList, setAttributesList] = useState([]);
  const [ finishList, setFinishesList ] = useState([]);
  const [ sizesList, setSizesList ] = useState([]);
  const [ sliderList, setSliderList ] = useState([]);
  const [ sliderTypeList, setSliderTypeList ] = useState([]);
  const [ storagesList, setStoragesList ] = useState([]);
  const [ colorsList, setColorsList ] = useState([]);
  const [ materialsList, setMaterialsList ] = useState([]);
  const [productCategoriesBarList, setProductCategoriesBarList] = useState([]);
  const [productCategoriesByBarList, setProductCategoriesByBarList] = useState(
    []
  );
  const [productCategoriesList, setProductCategoriesList] = useState([]);
  const [productSubCategoriesByCatList, setProductSubCategoriesByCatList] =
    useState([]);
  const [productSubCategoriesList, setProductSubCategoriesList] = useState([]);
  const [reviewsList, setReviewsList] = useState([]);
  const [imagesList, setImagesList] = useState([]);

  const fetchCountsList = () => {
    getCountsData(setCountList, config);
  };

  const fetchAdminsList = () => {
    getAdminsList(setAdminsList, config);
  };

  const fetchSlidersList = () => {
    getSliderList(setSliderList, config);
  };

  const fetchSliderTypeList = (query) => {
    getSliderTypeList(setSliderTypeList, config, query);
  };

  const fetchUsersList = () => {
    getUsersList(setUsersList, config);
  };

  const fetchTestimonialList = () => {
    getTestimonialList(setTestimonialList, config);
  };

  const fetchUserTypesList = () => {
    getUserTypesList(setUserTypesList, config);
  };

  const fetchCityList = () => {
    getCityList(setCityList, config);
  };

  const fetchBlogList = () => {
    getBlogList(setBlogList, config);
  };

  const fetchStoreList = () => {
    getStoreList(setStoreList, config);
  };

  const fetchOrdersList = (id) => {
    getOrdersList(setOrdersList, config, id);
  };

  const fetchOrderAnalytics = () => {
    getOrderAnalytics(setOrderAnalytics, config);
  };

  const fetchAnalyticsData = (query) => {
    if (query) {
      return getAnalytics(setAnalyticsData, config, query);
    }
    getAnalytics(setAnalyticsData, config);
  };

  const fetchBrandsList = () => {
    getBrandsList(setBrandsList, config);
  };

  const fetchMaterialsList = () => {
    getMaterialsList(setMaterialsList, config);
  };

  const fetchProductConfigsList = () => {
    getProductConfigsList(setProductConfigsList, config);
  };

  const fetchProductConfigsByProductsList = (id) => {
    getProductConfigsByProductsList(setProductConfigsByProductsList, config, id);
  };

  const fetchProductsList = () => {
    getProductsList(setProductsList, config);
  };

  const fetchAttributesList = () => {
    getAttributesList(setAttributesList, config);
  };

  const fetchFinishesList = () => {
    getFinishesList(setFinishesList, config);
  };

  const fetchSizesList = () => {
    getSizesList(setSizesList, config);
  };

  const fetchStoragesList = () => {
    getStoragesList(setStoragesList, config);
  };

  const fetchColorsList = () => {
    getColorsList(setColorsList, config);
  };

  const fetchProductCategoriesBarList = () => {
    getProductCategoriesBarList(setProductCategoriesBarList, config);
  };

  const fetchProductCategoriesByBarList = (id) => {
    getProductCategoriesByBarList(setProductCategoriesByBarList, config, id);
  };

  const fetchProductCategoriesList = () => {
    getProductCategoriesList(setProductCategoriesList, config);
  };

  const fetchProductSubCategoriesByCatList = (id) => {
    getProductSubCategoriesByCatList(
      setProductSubCategoriesByCatList,
      config,
      id
    );
  };

  const fetchProductSubCategoriesList = () => {
    getProductSubCategoriesList(setProductSubCategoriesList, config);
  };

  const fetchReviewsList = () => {
    getReviewsList(setReviewsList, config);
  };
  const fetchImagesList = (id) => {
    getProductImages(setImagesList, config, id);
  };

  // useMemo(() => {
  //   fetchAdminsList();
  //   fetchUsersList();
  //   fetchBrandsList();
  //   fetchProductsList();
  //   fetchProductCategoriesBarList();
  //   fetchProductCategoriesByBarList();
  //   fetchProductCategoriesList();
  //   fetchProductSubCategoriesList();
  //   fetchProductSubCategoriesByCatList();
  //   fetchReviewsList();
  //   fetchAttributesList();
  // }, [refresh])

  const value = {
    title,
    setTitle,
    // setRefresh,
    adminsList,
    fetchAdminsList,
    usersList,
    fetchUsersList,
    materialsList,
    fetchMaterialsList,
    cityList,
    fetchCityList,
    testimonialList,
    fetchTestimonialList,
    blogList,
    fetchBlogList,
    brandsList,
    fetchBrandsList,
    productsList,
    fetchProductsList,
    ordersList,
    fetchOrdersList,
    sliderList,
    fetchSlidersList,
    sliderTypeList,
    fetchSliderTypeList,
    analyticsData,
    fetchAnalyticsData,
    orderAnalytics,
    fetchOrderAnalytics,
    productCategoriesBarList,
    fetchProductCategoriesBarList,
    productCategoriesByBarList,
    fetchProductCategoriesByBarList,
    productCategoriesList,
    fetchProductCategoriesList,
    productSubCategoriesByCatList,
    fetchProductSubCategoriesByCatList,
    productSubCategoriesList,
    fetchProductSubCategoriesList,
    reviewsList,
    fetchReviewsList,
    attributesList,
    fetchAttributesList,
    finishList,
    fetchFinishesList,
    sizesList,
    fetchSizesList,
    storagesList,
    fetchStoragesList,
    colorsList,
    fetchColorsList,
    userTypesList,
    fetchUserTypesList,
    countList,
    fetchCountsList,
    productConfigsList,
    fetchProductConfigsList,
    productConfigsByProductsList,
    fetchProductConfigsByProductsList,
    fetchImagesList,
    imagesList,
    fetchStoreList,
    storeList
  };
  return <ListContext.Provider value={value}>{children}</ListContext.Provider>;
};

export default ListProvider;
